import {lazy} from "react";

const SearchUser = lazy(() => import("./SearchUser"));

const managementUserRoutes = [
    {
        path: "/management-user",
        element: <SearchUser/>,
    },
];

export default managementUserRoutes;